import { render, staticRenderFns } from "./CowsDehorningThirdPage.vue?vue&type=template&id=49c0edba&scoped=true&"
import script from "./CowsDehorningThirdPage.vue?vue&type=script&lang=js&"
export * from "./CowsDehorningThirdPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c0edba",
  null
  
)

export default component.exports